import request from './request'

/** 当前用户偏好画像 */
export function listPrefs() {
  return request.get('/prefs')
}

/** 对某 job 反馈（good: true=满意 false=不满意） */
export function feedbackJob(jobId, good) {
  return request.post('/prefs/feedback', null, {
    params: { id: jobId, good: good ? 1 : 0 }
  })
}
